import { useEffect, useState } from 'react';
import constant, { AvailableNodes, NodeType, TemplateStatus, ToastType } from '../../../../helper/constant';
import { useAIModelContext } from '../../../../context/ai-model.context';
import { useAIWorkflowContext } from '../../../../context/ai-workflow.context';
import { Handle } from '@xyflow/react';
import { renderNodeIcon } from '../../../../helper/helper';
import { Link, useParams } from 'react-router-dom';
import NodePrediction from '../components/NodePrediction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faEye, faGear, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';
import NodeStatus from '../components/NodeStatus';
import { NodeDeleteButton } from './InputNode';
import { executePendingWorkflowAPI } from '../../../../service/ai-model.service';
import { Image, OverlayTrigger, Popover } from 'react-bootstrap';
import { useAppContext } from '../../../../context/app.context';

const WorkflowNode = ({ data, id, workflow }) => {
    const { updateRightMenu } = useAIModelContext();
    const { showAlert } = useAppContext();
    const { updateSelecteNode, workflowExecution, workflowEdit } = useAIWorkflowContext();
    const [approved, setApproved] = useState(false);
    const params = useParams();

    useEffect(() => {
        if (workflowExecution && workflowExecution.executionId) {
            setApproved(false);
        }
    }, [workflowExecution?.executionId])

    const handleNodeClick = () => {
        updateRightMenu(true);
        updateSelecteNode({ id, data })
    };

    const onShowWorkflow = (e) => {
        e.stopPropagation();
    }

    const submitApproveOrReject = (approved) => {
        const payload = {
            executionId: workflowExecution.executionId,
            nodeId: id,
            approved: approved
        };
        executePendingWorkflowAPI(payload).then((r) => {
            if (r) {
                setApproved(approved);
                showAlert(r.message, ToastType.SUCCESS)
            }
        })
            .catch(e => console.log(e))
    }

    const renderWorkflowOptions = () => {
        return (
            <div className='d-flex gap-1 justify-content-center align-items-center'>
                {/* <OverlayTrigger placement="top" overlay={tooltipReject}> */}
                <Link
                    onClick={e => {
                        e.stopPropagation();
                        submitApproveOrReject(false);
                    }}
                    className='align-self-center fs-10'>
                    <FontAwesomeIcon icon={faXmarkCircle} className='text-danger' />
                    <p>Reject</p>
                </Link>
                {/* </OverlayTrigger> */}
                {/* <OverlayTrigger placement="top" overlay={tooltipApprove}> */}
                <Link
                    onClick={e => {
                        e.stopPropagation();
                        submitApproveOrReject(true);
                    }
                    }
                    className='align-self-center fs-10'><FontAwesomeIcon icon={faCheckCircle} className='text-success' />
                    <p>Approve</p>
                </Link>
                {/* </OverlayTrigger> */}
            </div>
        )
    }

    const renderViewLargeResults = () => {
        const popover = (
            <Popover id="popover-image" style={{ maxWidth: "none" }}>
                {data && data.url &&
                    <Image
                        src={data.url}
                        alt="Large preview"
                        fluid
                        rounded
                    />
                }
            </Popover>
        );
        return (
            <div className='d-flex justify-content-between align-items-center gap-2 px-2'>

                <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="right"
                    overlay={popover}>
                    <Link onClick={onShowWorkflow}

                        className='align-self-start fs-10'
                        target='_blank'
                        to={`/${constant.PAGES.HOME.AI_WORKFLOW}/${data.id}`}>
                        {<FontAwesomeIcon icon={faEye} size='1x' />}
                        <p>View Workflow</p>
                    </Link>
                </OverlayTrigger>

                <Link
                    className='align-self-start fs-10'>
                    {<FontAwesomeIcon icon={faGear} size='1x' />}
                    <p>Configuration</p>
                </Link>
            </div>
        )
    }

    const renderNodeDetails = () => {
        if (data && data.name) {
            return (
                <div className='d-flex flex-column'>
                    {/* {data.url && (<><div className='px-2 pb-2 node-details'>
                        <img src={data.url} alt={data.name} className='flownode-preview' crossOrigin='anonymous' />
                    </div>
                        {renderViewResults()}
                    </>)
                    } */}
                    {renderViewLargeResults()}
                    {(data.approval && workflowExecution && workflowExecution.executionId && !approved) && renderWorkflowOptions()}
                </div>
            )
        }
    }

    const renderNodePrediction = () => {
        return <NodePrediction id={id} templateId={data.templateId} workflowId={params.id} />
    }
    const renderDeleteButton = () => {
        if (workflowEdit)
            return <NodeDeleteButton id={id} />
    }

    const render = () => {
        if (data) {
            return (
                <>
                    <div className={`dndnode d-flex flex-column gap-1 input ${NodeType.WorkflowNode} `} onClick={handleNodeClick}>
                        {renderDeleteButton()}
                        {data &&
                            <div className='p-2 m-0 node-title d-flex justify-content-between align-items-center' style={{ backgroundColor: AvailableNodes[2].color }}>
                                <div className='d-flex align-items-center gap-1'>
                                    {renderNodeIcon(data.type, 25)}
                                    <p className='p-0 m-0 text-align-left'>{data.name || data.label}</p>
                                </div>
                                {workflow.status === TemplateStatus.COMPLETED && <NodeStatus id={id} name={workflow.name} />}
                            </div>
                        }
                        {renderNodeDetails()}
                        <Handle
                            type="target"
                            position="left"
                            style={{ background: '#555' }}
                            id={`${id}-target`}
                            isConnectable={true}
                        />
                        <Handle
                            type="source"
                            position="right"
                            style={{ background: '#555' }}
                            id={`${id}-source`}
                            isConnectable={true}
                        />
                    </div>
                    {renderNodePrediction()}
                </>
            )
        }
    }
    return render();
}

export default WorkflowNode